const WEIGHTS = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];
const VALUES: { [char: string]: number } = {
  a: 1,
  b: 2,
  c: 3,
  d: 4,
  e: 5,
  f: 6,
  g: 7,
  h: 8,
  j: 1,
  k: 2,
  l: 3,
  m: 4,
  n: 5,
  p: 7,
  r: 9,
  s: 2,
  t: 3,
  u: 4,
  v: 5,
  w: 6,
  x: 7,
  y: 8,
  z: 9,
  '1': 1,
  '2': 2,
  '3': 3,
  '4': 4,
  '5': 5,
  '6': 6,
  '7': 7,
  '8': 8,
  '9': 9,
  '0': 0,
};
export const validateVIN = (vin: string) => {
  const vinRegex = /^[A-HJ-NPR-Z\d]{3}[A-HJ-NPR-Z\d]{5}[\dX][A-HJ-NPR-Z\d][A-HJ-NPR-Z\d][A-HJ-NPR-Z\d]{6}$/;

  // validate vin is correct format
  if (vinRegex.test(vin)) {
    // go through each character and assign it a weighted value
    const values = Array.from(vin).map((char, index) => {
      return WEIGHTS[index] * VALUES[char.toLowerCase()];
    });

    // sum weighted values and mod 11
    const total = values.reduce((acc, curr) => acc + curr, 0) % 11;

    // remainder is the expected 9th digit, with X representing 10
    const digit = total === 10 ? 'x' : total.toString();

    return digit === vin.charAt(8).toLowerCase();
  }

  return false;
};
